import React from "react";

const FlagSVG = ({ height = 13, width = 14, color, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11.25C3 11.25 3.75 10.5 6 10.5C8.25 10.5 9.75 12 12 12C14.25 12 15 11.25 15 11.25V2.25C15 2.25 14.25 3 12 3C9.75 3 8.25 1.5 6 1.5C3.75 1.5 3 2.25 3 2.25V11.25Z"
        stroke={color || "#6570FC"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.5V11.25"
        stroke={color || "#6570FC"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FlagSVG;
